/** Structural on purpose, so both the shared data model's `EventInstance` and the form's value instance satisfy it without being named here. */
export interface EventInstanceContent {
    date: { year: number | null; month: number | null; day: number | null; endYear?: number | null };
    gpid: string;
    location: string;
}

/** `locationExactness` is `null` by type, not by chance: this module can't know whether a consumer stores the form's exactness scope or the data model's exactness object, so a default instance sets neither, and every consumer type must accept `null` there. */
export interface DefaultEventInstance {
    date: { year: number | null; month: number | null; day: number | null; endYear: number | null };
    gpid: string;
    location: string;
    dateProximity: { year: number | null; month: number | null; day: number | null };
    locationExactness: null;
}

/** The year proximity default comes from the experiment: test arm (`10`) carries `{ year: 10, month: 0, day: 0 }`, control arm (`null`) carries no proximity at all. */
export const createEmptyEventInstance = (defaultYearProximity: number | null): DefaultEventInstance => ({
    date: { year: null, month: null, day: null, endYear: null },
    gpid: "",
    location: "",
    dateProximity: {
        year: defaultYearProximity,
        month: defaultYearProximity !== null ? 0 : null,
        day: defaultYearProximity !== null ? 0 : null,
    },
    locationExactness: null,
});

/** Proximity and exactness are deliberately not consulted — they are settings on the slot, not content in it. */
export const isEventInstanceEmpty = ({ date, location, gpid }: EventInstanceContent): boolean => {
    const hasDate = [date.year, date.month, date.day, date.endYear].some((part) => typeof part === "number");
    return !hasDate && !location && !gpid;
};
